const en = {
  title: 'Dealers',
  subtitle: 'Dealers who send in repairs on behalf of customers',
  addDealer: '+ Add Dealer',
  errorLoading: 'Error loading dealers: {{error}}',
  noDealersTitle: 'No Dealers Yet',
  noDealersMessage: 'Create your first dealer to get started',
  templateId: 'Template ID',
  contact: 'Contact',
  contactPerson: 'Contact Person',
  phone: 'Phone',
  email: 'Email',
  street: 'Street',
  zip: 'ZIP',
  city: 'City',
  nickname: 'Nickname',
  editDealer: 'Edit Dealer',
  createDealer: 'Create New Dealer',
  saveChanges: 'Save Changes',
  deleteDealer: 'Delete Dealer',
  confirmDelete: 'Are you sure you want to delete "{{name}}"?',
  saveFailed: 'Failed to save dealer',
};

const de = {
  title: 'Händler',
  subtitle: 'Händler, die Reparaturen im Auftrag von Kunden einsenden',
  addDealer: '+ Händler hinzufügen',
  errorLoading: 'Fehler beim Laden der Händler: {{error}}',
  noDealersTitle: 'Noch keine Händler',
  noDealersMessage: 'Erstellen Sie Ihren ersten Händler, um loszulegen',
  templateId: 'Vorlagen-ID',
  contact: 'Kontakt',
  contactPerson: 'Ansprechpartner',
  phone: 'Telefon',
  email: 'E-Mail',
  street: 'Straße',
  zip: 'PLZ',
  city: 'Stadt',
  nickname: 'Spitzname',
  editDealer: 'Händler bearbeiten',
  createDealer: 'Neuen Händler erstellen',
  saveChanges: 'Änderungen speichern',
  deleteDealer: 'Händler löschen',
  confirmDelete: 'Möchten Sie „{{name}}" wirklich löschen?',
  saveFailed: 'Händler konnte nicht gespeichert werden',
};

const dealers = { en, de };
export default dealers;
